import styled from 'styled-components';
import Table from 'core/table';
import { WarningBanner } from 'ui/banner';
import { pxToRem } from 'utils/convert';
import { spacing, colors } from 'ui/theme';

export const CheckboxContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.eighth};
`;

export const CheckmarkContainer = styled.div`
  display: flex;
  gap: ${spacing.quarter};
  justify-content: space-evenly;
`;
export const FormButtonContainer = styled.div`
  align-items: center;
  display: flex;
  gap: ${spacing.quarter};
  justify-content: flex-end;
`;

export const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.base};
  margin-top: ${spacing.base};
  margin-bottom: ${pxToRem(100)};
  width: ${pxToRem(575)};
  .ui.input {
    /** can be removed once the inputs are updated to ui/ inputs */
    width: 100%;
  }
`;

export const StyledTable = styled(Table)`
  > div {
    overflow: visible;
    > div {
      overflow: visible;
    }
  }
`;

export const StyledWarningBanner = styled(WarningBanner)`
  margin: ${spacing.half} 0;
  padding: ${spacing.half};
  padding-right: ${spacing.double};
`;

export const TooltipTrigger = styled.div`
  cursor: pointer;
  text-decoration-color: ${colors.grey25};
  text-decoration-line: underline;
`;
